import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_210: DocMigration = {
  maxSchemaVersion: "0.0.210",
  description: "Make sure that IDs between optionSets table and each option set 'id' field match",
  apply(json: any) {
    // The key on the optionSets table is the "correct" one, used by conditions and optionChoices
    Object.entries(json.optionSets ?? {}).forEach(([optionSetId, optionSet]) => {
      // Fix option set ID
      (optionSet as any).id = optionSetId;

      // Fix parentId in child options
      Object.entries((optionSet as any).options).forEach(([_, option]) => {
        (option as any).parentId = optionSetId;
      });
    });

    return json;
  },
};

export default migration_0_0_210;
